import React, { useState, useEffect, useContext } from "react";
import { Buffer } from "buffer";
import Layout from "../Components/Layout";
import Login from "../Components/Login";
import Menu from "../Components/Menu";
import { getCustomer, getAlarmAccounts } from "../Components/Helpers/Account";
import Spinner from "../Components/Utils/Spinner";
import ErrorResponse from "../Components/Utils/ErrorResponse";
import { AuthContext, ThemeConstants, ThemeContext } from "../App";

export default function Home({}) {
  const auth = useContext(AuthContext);
  const themeConfig = useContext(ThemeContext);
  const themeConstants = useContext(ThemeConstants);

  const [customer, setCustomer] = useState();
  const [alarmAccounts, setAlarmAccounts] = useState();
  const [customerAddresses, setCustomerAddresses] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [networkErr, setNetworkErr] = useState(false);

  useEffect(() => {
    if (auth && auth.isAuthenticated && auth.user) {
      const accessToken = auth.user.signInUserSession.accessToken.jwtToken;
      const accessTokenExp =
        auth.user.signInUserSession.accessToken.payload.exp;
      const accessTokenExpTime = new Date(accessTokenExp * 1000).getTime();
      const idToken = auth.user.signInUserSession.idToken.jwtToken;
      const idTokenDecodedBuffer = Buffer.from(
        idToken.split(".")[1],
        "base64"
      ).toString();
      const idTokenDecodedJSON = JSON.parse(idTokenDecodedBuffer);
      const customerID = idTokenDecodedJSON["custom:ns_customer_id"];

      if (accessTokenExpTime < new Date()) {
        location.reload();
        return false;
      }

      // Fetch LoggedIn Customer Details
      getCustomer(accessToken, customerID)
        .then((result) => {
          setCustomer(result.customer);
          setCustomerAddresses(result.customer.addresses);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
          setNetworkErr(true);
        });

      // Fetch Customer's Alarm Accounts
      getAlarmAccounts(accessToken, customerID)
        .then((result) => {
          setAlarmAccounts(result.accounts.items);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
          setNetworkErr(true);
        });
    }
  }, [auth]);

  return (
    <>
      <Layout auth={auth} isLoading={isLoading} networkErr={networkErr}>
        {auth && auth.isAuthenticated && auth.user ? (
          <>
            <Menu accountMenuActive={true} />
            {!isLoading ? (
              <>
                {customer && (
                  <div className="bg-gray-100 p-6 sm:p-10 max-w-4xl my-10 mx-4 lg:mx-auto rounded-md flex">
                    <div>
                      <h3 className="text-lg">Contact Information</h3>
                      <p>{customer.billingContact}</p>
                      <p>{customer.billingEmail}</p>
                    </div>
                    <div className="ml-auto">
                      {/* edit buttons goes here */}
                    </div>
                  </div>
                )}
                {customerAddresses && (
                  <div className="bg-gray-100 p-4 sm:p-10 max-w-4xl w-auto lg:w-full my-10 mx-4 lg:mx-auto rounded-md flex flex-col">
                    <h3 className="text-lg">Address Book</h3>
                    <div className="flex flex-col sm:flex-row justify-center mt-3">
                      {customerAddresses.map((item) => {
                        return (
                          <div
                            key={item.id}
                            className="bg-white text-gray-600 my-4 mx-1 px-4 py-6 md:p-6 w-auto sm:w-1/2 shadow-md rounded-md flex flex-col"
                          >
                            <h3 className="text-sm border-b pb-2 mb-2">
                              {item.defaultBilling
                                ? "Billing Address"
                                : "Shipping Address"}
                            </h3>
                            <p>{item.addressBookAddress.addressee}</p>
                            <p>
                              {item.addressBookAddress.addr1},{" "}
                              {item.addressBookAddress.city}
                            </p>
                            <p>
                              {item.addressBookAddress.state},{" "}
                              {item.addressBookAddress.zip}
                            </p>
                            <p className="text-xs border-t pt-2 mt-2">
                              <span className="mr-1">
                                <i
                                  className="fa fa-info-circle"
                                  aria-hidden="true"
                                ></i>
                              </span>
                              {item.defaultBilling === item.defaultShipping
                                ? "Shipping Address is same as Billing Address"
                                : ""}
                            </p>
                          </div>
                        );
                      })}
                      <div className="ml-auto">
                        {/* edit buttons goes here */}
                      </div>
                    </div>
                  </div>
                )}
                {alarmAccounts?.length > 0 && (
                  <div className="bg-gray-100 p-4 sm:p-10 max-w-4xl w-auto lg:w-full my-10 mx-4 lg:mx-auto rounded-md flex flex-col">
                    <h3 className="text-lg">Alarm.com Accounts</h3>
                    <div className="flex flex-col sm:flex-row flex-wrap mt-3">
                      {alarmAccounts.map((item) => {
                        return (
                          <div
                            key={item.id}
                            className="bg-white text-gray-600 my-4 md:mx-2 p-6 w-full sm:w-full shadow-md rounded-md flex flex-col"
                          >
                            {/* <h3 className="text-sm border-b pb-2 mb-2">
                              Plan: <span>{item.plan}</span>
                            </h3> */}
                            <p className="break-all">{item.primary_email}</p>
                            <p>
                              {item.address1}, {item.city}
                            </p>
                            <p>
                              {item.state ? `${item.state},` : ""} {item.zip}
                            </p>
                            <p className="text-sm border-t mt-2 pt-2">
                              Alarm.com ID:
                              <span className="text-gray-500 ml-1">
                                {item.id}
                              </span>
                            </p>
                            <p className="text-sm pt-2">
                              Account Status:
                              {item.is_terminated ? (
                                <span className="text-gray-500 ml-1">
                                  Inactive
                                </span>
                              ) : (
                                <span className="text-green-500 ml-1">
                                  Active
                                </span>
                              )}
                            </p>
                            {item.termination_date?.length > 0 && (
                              <p className="text-sm">
                                Terminated On:{" "}
                                <span className="text-gray-600 ml-1">
                                  {item.termination_date}
                                </span>
                              </p>
                            )}
                            <a
                              className={`text-sm underline mt-3`}
                              href={`${themeConstants.MARKETING_URL}/home-login`}
                            >
                              Manage this account
                            </a>
                          </div>
                        );
                      })}
                      <div className="ml-auto">
                        {/* edit buttons goes here */}
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <Spinner />
            )}
            {networkErr && (
              <ErrorResponse
                setNetworkErr={setNetworkErr}
                closeEvent="reload"
              />
            )}
          </>
        ) : (
          <Login auth={auth} />
        )}
      </Layout>
    </>
  );
}
